import { z } from "zod"

export const personPJSchema = z.object({
  companyName: z.string().min(1, "Nome da empresa é obrigatório"),
  cnpj: z.string().min(14, "CNPJ deve ter 14 dígitos"),
  businessAddress: z.string().min(1, "Endereço comercial é obrigatório"),
  businessDistrict: z.string().min(1, "Bairro comercial é obrigatório"),
  businessCityState: z.string().min(1, "Cidade e estado comercial são obrigatórios"),
  businessZipCode: z.string().min(8, "CEP deve ter 8 dígitos"),
  cnaeCode: z.string().min(1, "Código CNAE é obrigatório"),
  municipalRegistration: z.string().optional(),
  ancineRegistrationNumber: z.string().min(1, "Número de cadastro na ANCINE é obrigatório"),
  bankName: z.string().optional(),
  bankBranch: z.string().optional(),
  checkingAccount: z.string().optional(),
  pixKey: z.string().optional(),
})

export type PersonPJSchema = z.infer<typeof personPJSchema>
